// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__2--fo"};